// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Image as RawImage } from "lucide-react";
export const Image = /* @__PURE__ */ createIcon(RawImage, "Image", 2);
